import React from 'react';
import './PostHoldConfirm.css';

/**
 * "Post anyway?" — shown when the Post endpoint answered 409 because the ERA
 * was held as a duplicate or as paying an already-paid claim. Lists the
 * reasons the backend sent; Post anyway re-sends with confirm=true.
 */
export default function PostHoldConfirm({ reasons, onConfirm, onCancel, busy }) {
  const list = Array.isArray(reasons) ? reasons : [];
  return (
    <div className="modal-overlay" onClick={() => !busy && onCancel()}>
      <div
        className="modal-content post-hold-confirm"
        role="dialog"
        aria-labelledby="post-hold-confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 id="post-hold-confirm-title">Post anyway?</h3>
          <button type="button" className="close-btn" onClick={onCancel} disabled={busy}>
            &times;
          </button>
        </div>
        <p className="post-hold-confirm-lead">
          This ERA was held for review. Posting it could apply the same money twice.
        </p>
        <ul className="post-hold-confirm-reasons">
          {list.map((r) => (
            <li key={r.code} data-code={r.code}>
              {r.label || r.code}
              {r.other_remittance_id ? ` (see remittance #${r.other_remittance_id})` : ''}
            </li>
          ))}
        </ul>
        <div className="modal-footer post-hold-confirm-footer">
          <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button type="button" className="btn-post" onClick={onConfirm} disabled={busy}>
            {busy ? 'Posting...' : 'Post anyway'}
          </button>
        </div>
      </div>
    </div>
  );
}
